var path = 'batch/gdprRequest/details/gdprRequestDetails.tpl.html';
var html = "<react-component name='gdpr-details-table' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;